import React, { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import TailwindStudentsAssignTableComponent from 'site/pages/shared/events-and-requests/tabs/students-assign-component-tw';
import { connect } from 'redux-scaffolding-ts';
import { EventFormStore, EventFormViewModel } from 'stores/events/event-form-store';
import { StudentsTabViewModel } from 'site/pages/shared/events-and-requests/tabs/students-assign-component';

export interface EventStudentContainerProp extends WithTranslation {
  event: EventFormViewModel;
  readOnly: boolean;
  eventFormStore?: EventFormStore;
}

export interface EventStudentContainerState {
  event: EventFormViewModel;
}

@connect(['eventFormStore', EventFormStore])
class EventStudentContainer extends Component<EventStudentContainerProp, EventStudentContainerState> {
  state: EventStudentContainerState = {
    event: this.props.event
  };

  private handleOnStudentsChange = (newValue: StudentsTabViewModel) => {
    this.props.eventFormStore.change({
      students: newValue.students,
      studentsAssigned: newValue.studentsAssigned,
      studentsRequested: newValue.studentsRequested,
      studentsMandatory: !newValue.studentsOptional
    });
    this.setState({ event: { ...this.state.event, ...newValue } });
  };

  render() {
    const { readOnly } = this.props;
    const event = this.state.event;
    const value: StudentsTabViewModel = {
      students: event.students,
      studentsAssigned: event.studentsAssigned,
      studentsRequested: event.studentsRequested,
      studentsOptional: !event.studentsMandatory
    };

    return (
      <TailwindStudentsAssignTableComponent cameFrom="Event" readOnly={readOnly} value={value} onChange={this.handleOnStudentsChange} />
    );
  }
}

export default withTranslation()(EventStudentContainer);
